import React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import { colors } from '../../../utils/theme';
import { hexToRgbA } from '../../../utils/hexToRGBA';
import Text from '../Text';

export type SectionHeaderProps = {
    text: string;
    style?: StyleProp<ViewStyle>;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({ text, style }) => {
    return (
        <View
            style={[
                {
                    backgroundColor: hexToRgbA(colors.Black, 0.1),
                    padding: 10,
                    width: '100%',
                    borderRadius: 12,
                },
                style,
            ]}
        >
            <Text variant="bold-h4">{text}</Text>
        </View>
    );
};

export default React.memo(SectionHeader);
